import React, { type FC } from "react"

import { SectionTitleSlideTemplate } from "../../SlideTemplates/SectionTitleSlide"

export const SemanticHTMLTitle: FC = () => (
  <SectionTitleSlideTemplate heading="Semantic HTML" />
)
